module.exports = __webpack_public_path__ + "media/16.6ea10c21.mp3";